<div fxLayout="column" fxLayoutAlign="start start">
    @if (isShowDocumentMode) {
    <div style="width: 100%;">
        <div fxLayout="row" fxLayoutAlign="end">
            <forge-button aria-label="Hide" (click)="hide()">
                <forge-icon name="visibility_off"></forge-icon>
                Hide
            </forge-button>
        </div>
        <iframe
            style="height: 849px; width: 100%; border: 1px solid var(--forge-theme-text-lowest, rgba(0,0,0,0.12)); border-top: none;"
            [src]="documentUrl"></iframe>
    </div>
    }
    @if (!isShowDocumentMode) {
    <div fxLayout="row" fxLayoutAlign="start center" class="file-picker-container" [ngClass]="{'invalid': isInvalid}">
        <div>
            <forge-label-value [attr.telemetry]="telemetryLabel">
                <span slot="label" [ngClass]="{'file-required': isRequired}">{{label}}</span>
                <span slot="value" fxLayout="row">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <forge-file-picker [disabled]="isViewOnly" [attr.accept]="allowedTypes"
                            [attr.multiple]="allowMultiple" [attr.compact]="!showDragDrop ? '' : undefined"
                            [attr.max_size]="maxSize" (forge-file-picker-change)="onFileSelected($event)">
                            <span slot="primary">{{primaryMessage}}</span>
                            <span slot="secondary">
                                Maximum file size: {{formatMaxSize}}
                                @if (showTypeField) {
                                <span><br>({{allowedTypesView}})</span>
                                }
                            </span>
                            <forge-button variant="outlined" [dense]="compact">
                                {{buttonMessage}}
                            </forge-button>
                        </forge-file-picker>
                        @if (filesExist && allowMultiple) {
                        <div style="width: 100%;">
                            @for (file of files; track file) {
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                                <span class="file-list--item forge-typography--label1">{{file.FileName}}</span>
                                @if (!isViewOnly) {
                                <forge-icon-button dense telemetry="Submission-Clear" (click)="clear(file)">
                                    <forge-tooltip>Remove '{{file.FileName}}'</forge-tooltip>
                                    <forge-icon name="close"></forge-icon>
                                </forge-icon-button>
                                }
                            </div>
                            }
                        </div>
                        }
                        @if (filesExist && !allowMultiple) {
                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                            <span class="file-list--item forge-typography--label1">{{file.FileName}}</span>
                            @if (!isViewOnly) {
                            <forge-icon-button dense telemetry="Clear" (click)="clear(null)">
                                <forge-tooltip>Remove '{{file.FileName}}'</forge-tooltip>
                                <forge-icon name="close"></forge-icon>
                            </forge-icon-button>
                            }
                        </div>
                        }
                        @if (badFileList.length > 0 && allowMultiple && filesExist) {
                        <forge-divider style="width: 100%; margin: .5rem;">
                        </forge-divider>
                        }
                        @for (file of badFileList; track file) {
                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                            <div fxLayout="column" fxLayoutAlign="start start">
                                <span class="file-list--item forge-typography--label1">{{file.FileName}}</span>
                                <span class="forge-typography--label1 tyl-color-danger"
                                    style="margin-top: -0.25rem;">{{file.Message}}</span>
                            </div>
                            <forge-icon name="error" external="true" slot="trailing" class="tyl-color-danger" id="true">
                            </forge-icon>
                        </div>
                        }
                        @if (isDownloadable || isShowable) {
                        <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%;">
                            <forge-divider style="width: 100%; margin: .5rem;"></forge-divider>
                            <div fxLayout="row" fxLayoutAlign="center center">
                                @if (isDownloadable) {
                                <forge-button telemetry="Submission-Download" (click)="download()">
                                    <forge-icon name="download"></forge-icon>
                                    Download
                                </forge-button>
                                }
                                @if (isShowable) {
                                <forge-button aria-label="Show" (click)="show()">
                                    <forge-icon name="visibility"></forge-icon>
                                    Show
                                </forge-button>
                                }
                            </div>
                        </div>
                        }
                    </div>
                </span>
            </forge-label-value>
            @if (isInvalid) {
            <div class="forge-typography--label1 error-red">Please select a file.</div>
            }
        </div>
    </div>
    }
</div>